<template>
  <pt-news-form ref="form" class="pt-news-form__withData" :id="id" :newsCategories="newsCategories" @submit="submit" :newsDetail="newsDetail" :content="newsContent"
  :isEdit="isEdit"></pt-news-form>
</template>

<script>
import PtNewsForm from './form'
export default {
  name: 'pt-news-form__withData',
  components: {
    'pt-news-form': PtNewsForm
  },
  computed: {
    form () {
      return this.$refs.form
    }
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      newsCategories: [],
      newsDetail: {},
      newsContent: ''
    }
  },
  methods: {
    getNewCategories () {
      this.$store.dispatch('newCategories').then(res => {
        this.newsCategories = res
      }).catch(err => {
        this.$message.error(err || '获取新闻分类失败')
      })
    },
    submit (isPublish) {
    //   this.form.getEdiotrContent()
      console.log(this.form.formValue)
      this.form.validate().then(formValue => {
        let apiUrl = isPublish ? 'saveAndPublishNews' : (this.isEdit ? 'editNews' : 'creatNews')
        // let apiUrl = this.isEdit ? 'editNews' : (isPublish ? 'createdAndPublishNews' : 'creatNews')
        // if (isPublish) {
        //   this.$emit('publishLoad', true)
        // } else {
        this.$emit('submitLoad', true)
        // }
        this.$store.dispatch(apiUrl, formValue).then(data => {
          // doing something ...
          this.$message.success('新建新闻成功')
          //   if (isPublish) {
          //     this.$emit('publishLoad', false)
          //   } else {
          this.$emit('submitLoad', false)
          //   }
          history.go(-1)
        }).catch(errorMessage => {
          console.error(errorMessage)
          //   if (isPublish) {
          //     this.$emit('publishLoad', false)
          //   } else {
          this.$emit('submitLoad', false)
          //   }
          this.$message.error(errorMessage)
        })
      })
    },
    getNewsDetail () {
      this.$store.dispatch('newsDetail', this.id).then(res => {
        this.newsDetail = res
        this.newsContent = res.content
      }).catch(err => {
        this.$message.error(err || '获取新闻详情失败')
      })
    }
  },
  created () {
    this.getNewCategories()
    if (this.isEdit) {
      this.getNewsDetail()
    }
  }
}
</script>
